import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CmsArea } from '@domgen/dgx-fe-cms';
import { ENVIRONMENT } from '@domgen/dgx-fe-config';
import { SeoPage } from '@domgen/dgx-fe-seo';
import { EditableArea } from '@magnolia/angular-editor';
import { AppEnvironment } from 'apps/dg-self-fix/src/app/models/environment/app-environment.type';
import { FeedbackComponent } from 'libs/self-fix/feature-components/src/lib/components/feedback/feedback.component';
import { SmartFixCustomProgressStepperComponent } from 'libs/self-fix/feature-components/src/lib/components/progress-stepper/progress-stepper.component';
import { RedirectToMMRComponent } from 'libs/self-fix/feature-components/src/lib/components/redirect-to-mmr/redirect-to-mmr.component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    EditableArea,
    SmartFixCustomProgressStepperComponent,
    FeedbackComponent,
    RedirectToMMRComponent,
  ],
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss'],
})
@SeoPage()
export class ArticleComponent implements OnInit {
  @Input() main!: CmsArea;
  formattedSteps: any[] = [];
  articleTitle: string = '';
  startPagePresent: boolean = false;

  constructor(
    private router: Router,
    @Inject(ENVIRONMENT) public environment: AppEnvironment
  ) {}

  ngOnInit(): void {
    const articleCMSData = this.main[0] ?? this.main['00'];
    this.articleTitle = articleCMSData?.title;
    this.startPagePresent = articleCMSData?.startPage;

    // Purpose of this is to extract and filter article data from
    // the CMS content passed to the component in main, otherwise the stepper will not work
    this.formattedSteps = Object.values(articleCMSData?.steps ?? {}).filter(
      (step) => typeof step === 'object' && !Array.isArray(step)
    );
  }

  isVideoPath(): boolean {
    const currentUrl = this.router.url;
    return currentUrl.includes('/videos');
  }
}
